// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation, useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import * as QueryString from 'query-string';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { FundModelRequestToJSON, FundModelResponseFromJSON, ModelAssociationFromJSON, ModelAssociationToJSON, } from '../models';
/**
 * Retrieve model associations via GET
 * GET all model associations
 */
export function getModelAssociationRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/modelassociation` + queryString,
        meta,
        update: requestConfig.update || {
            ModelAssociation: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(ModelAssociationFromJSON);
            return {
                ModelAssociation: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetModelAssociation`;
    return config;
}
/**
* Retrieve model associations via GET
* GET all model associations
*/
/**
 * Use this selectors to get a record of all Array<ModelAssociation>, with their ids as keys
 * @returns A record of Array<ModelAssociation> object, with their ids as keys
 */
export const useModelAssociationRecordSelector = () => useSelector((state) => state.entities.ModelAssociation, isEqual);
const ModelAssociationArraySelector = createSelector((state) => state.entities.ModelAssociation, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<ModelAssociation>.
 * If you are doing transformation on this object, consider using useModelAssociationRecordSelector instead for performances
 * @returns An array containing all loaded ModelAssociation
 */
export const useModelAssociationArraySelector = () => useSelector(ModelAssociationArraySelector, isEqual);
/**
 * Request hook for Array<ModelAssociation>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetModelAssociation = (customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getModelAssociationRaw(customQueryConfig));
    return [
        useModelAssociationArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getModelAssociation(requestConfig) {
    return getModelAssociationRaw(requestConfig);
}
/**
 * Gets the list of default models associated to the list of funds given as an input
 * Get Funds\' Default Models
 */
export function postCffDefaultModelsRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cff/default-models` + queryString,
        meta,
        update: requestConfig.update || {
            ModelAssociation: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: requestParameters.fundModelRequest?.map(FundModelRequestToJSON),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(FundModelResponseFromJSON);
            return {
                ModelAssociation: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `PostCffDefaultModels-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Gets the list of default models associated to the list of funds given as an input
* Get Funds\' Default Models
*/
/**
 * Mutation hook to upsert an Array<FundModelResponse>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an Array<FundModelResponse>
 */
export const usePostCffDefaultModels = (customQueryConfig) => {
    return useMutation((fundModelRequest, customQueryParam) => postCffDefaultModelsRaw({ fundModelRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postCffDefaultModels(requestParameters, requestConfig) {
    return postCffDefaultModelsRaw(requestParameters, requestConfig);
}
/**
 * Gets the list of models associated to the list of funds given as an input
 * Get Funds\' Models
 */
export function postCffFundsModelsRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cff/funds-models` + queryString,
        meta,
        update: requestConfig.update || {
            ModelAssociation: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: requestParameters.fundModelRequest?.map(FundModelRequestToJSON),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(FundModelResponseFromJSON);
            return {
                ModelAssociation: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `PostCffFundsModels-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Gets the list of models associated to the list of funds given as an input
* Get Funds\' Models
*/
/**
 * Mutation hook to upsert an Array<FundModelResponse>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an Array<FundModelResponse>
 */
export const usePostCffFundsModels = (customQueryConfig) => {
    return useMutation((fundModelRequest, customQueryParam) => postCffFundsModelsRaw({ fundModelRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postCffFundsModels(requestParameters, requestConfig) {
    return postCffFundsModelsRaw(requestParameters, requestConfig);
}
/**
 * Endpoint to update and create new relationships between funds and applied cashflow models
 * Put model association
 */
export function putModelAssociationRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.restore !== undefined) {
        queryParameters['restore'] = requestParameters.restore;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/modelassociation` + queryString,
        meta,
        update: requestConfig.update || {
            ModelAssociation: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'PUT',
            headers: headerParameters,
        },
        body: requestParameters.modelAssociation?.map(ModelAssociationToJSON),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(ModelAssociationFromJSON);
            return {
                ModelAssociation: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `PutModelAssociation-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Endpoint to update and create new relationships between funds and applied cashflow models
* Put model association
*/
/**
 * Mutation hook to upsert an Array<ModelAssociation>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an Array<ModelAssociation>
 */
export const usePutModelAssociation = (customQueryConfig) => {
    return useMutation((restore, modelAssociation, customQueryParam) => putModelAssociationRaw({ restore, modelAssociation }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function putModelAssociation(requestParameters, requestConfig) {
    return putModelAssociationRaw(requestParameters, requestConfig);
}
